import React from 'react';

const WhyChooseUs = () => {
  const reasons = [
    {
      title: 'Reinvention',
      description: 'When businesses outgrow their markets and need to scale, we provide solutions for this growth and expansion.',
    },
    {
      title: 'Transformation',
      description: 'When established brands search for ways to reinvent themselves for the modern internet culture while maintaining their personality.',
    },
    {
      title: 'Breakthrough',
      description: 'We help startup first-timers design and build their product, roll it out, and get funded.',
    },
  ];

  return (
    <section className="py-20 md:py-28" style={{ background: '#F8FAFC' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-14">
          <p className="text-sm font-semibold uppercase tracking-widest mb-3 font-heading" style={{ color: '#2693FF' }}>
            Companies hire us
          </p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-slate-900 font-heading">
            When it's time for a key change
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="card-lift bg-white rounded-2xl p-7 border border-slate-100 group"
              style={{ boxShadow: '0 1px 4px rgba(0,0,0,0.04)' }}
            >
              <h3 className="text-xl font-bold text-slate-900 font-heading mb-3 group-hover:text-[#2693FF] transition-colors">
                {reason.title}
              </h3>
              <p className="text-sm text-slate-500 leading-relaxed">
                {reason.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
